<template>
  <div class="animate__animated animate__fadeIn">
    <div class="d-flex">
      <div class="form">
        <el-form
          class="form__create"
          ref="formCreate"
          :model="dataForm"
          :rules="validForm"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="1. Sử dụng mẫu" prop="dda_template_id">
                <el-select
                  clearable
                  filterable
                  v-model="dataForm.dda_template_id"
                  placeholder="Chọn mẫu văn bản"
                  @change="onChangeTemplate(dataForm.dda_template_id)"
                >
                  <el-option
                    v-for="(item, index) in dataDefault.listTemplates"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="2. Phân loại mẫu">
                <el-select
                  disabled
                  v-model="dataForm.dda_category_id"
                  placeholder="Phân loại mẫu"
                >
                  <el-option
                    v-for="(item, index) in dataDefault.listCategories"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="3. Tên văn bản" prop="name">
                <el-input
                  type="textarea"
                  clearable
                  :autosize="{ minRows: 3, maxRows: 5 }"
                  v-model="dataForm.name"
                  @change="() => { dataForm.name = dataForm.name.trim() }"
                  placeholder="Nhập tên văn bản"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="4. Số văn bản" prop="code">
                <el-input
                  v-model.trim="dataForm.code"
                  clearable
                  placeholder="Nhập số văn bản"
                  @input="forceUpdateUI"
                  @change="() => { dataForm.code = dataForm.code.trim().toUpperCase(); changeCode(dataForm.code) }"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <p class="title-note mb-1">5. Thời điểm có hiệu lực (Mặc định thời điểm hiệu lực bắt đầu từ thời điểm hoàn thành ký)</p>
              <el-form-item prop="effected_date">
                <div class="d-flex custom-label" slot="label">
                  <span>Chuyển để tự cấu hình!</span>
                  <el-switch
                    v-model="haveEffectedDate"
                    @change="onChangeEffectedDate(haveEffectedDate)"
                  ></el-switch>
                </div>
                <el-date-picker
                  @input="forceUpdateUI"
                  :disabled="!haveEffectedDate"
                  clearable
                  v-model="dataForm.effected_date"
                  :picker-options="pickerOptions"
                  type="date"
                  placeholder="Ngày hiệu lực"
                  :format="'dd/MM/yyyy'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <div class="preview">
        <div class="preview-content">
          <iframe
            id="iframe-preview-ed"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>

    <div class="d-flex at-center button-group">
      <el-button type="danger" plain @click="onCancelForm">Hủy</el-button>
      <el-button type="primary" @click="onSubmitForm">Tiếp theo</el-button>
    </div>
  </div>
</template>

<script>
import MethodService from '../../../service/MethodService'
import DraffDocumentAutoModel from '../DocumentDrafting/Composer/DraffDocumentAutoModel'
import DdaTemplateApi from '@/moduleApi/DdaTemplateApi'
import DdaCategoryApi from '@/moduleApi/DdaCategoryApi'
import DdaCodesApi from '@/moduleApi/DdaCodesApi'
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi'
import toastr from 'toastr'

const STORAGE_KEY = 'dataFormElectronicDocument'

export default {
  data() {
    return {
      haveEffectedDate: false,
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      currentUser: MethodService.getCurrentUser(),
      userProfile: MethodService.getUserProfile(),
      validForm: DraffDocumentAutoModel.validForm,
      bodyIframe: '',
      content: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()
        },
      },
      dataDefault: {
        listTemplates: [],
        listCategories: [],
        listParamMergeFields: [],
        company: MethodService.getCompanyInfo(),
        listCategoriesAndCode: []
      }
    }
  },
  methods: {
    forceUpdateUI() {
      this.$forceUpdate()
    },
    async initDataDefault() {
      this.dataDefault.listCategoriesAndCode = []
      let ddaTemplateApiRes, ddaCategoryApiRes, allParamMergeFields
      ;[ddaTemplateApiRes, ddaCategoryApiRes, allParamMergeFields] = await Promise.all([
        DdaTemplateApi.list({ limit: 1000, fields: 'id,name,dda_category_id,content' }),
        DdaCategoryApi.list({ limit: 100, fields: 'id,name,code' }),
        DdaTemplateApi.GetParamValuesForContractTemplate()
      ])
      this.dataDefault.listTemplates = ddaTemplateApiRes.result
      this.dataDefault.listCategories = ddaCategoryApiRes.result
      this.dataDefault.listParamMergeFields = allParamMergeFields.result
      if (this.dataDefault.listParamMergeFields['{{@SoHopDong}}'] == '') {
        this.dataDefault.listParamMergeFields['{{@SoHopDong}}'] = '......................'
      }
    },
    async onChangeTemplate(ddaTemplateId) {
      if (!ddaTemplateId) {
        this.dataForm.dda_category_id = null
        this.dataForm.code = null
        return
      }
      let template = this.dataDefault.listTemplates.find(item => item.id == ddaTemplateId)
      this.dataForm.dda_category_id = template.dda_category_id
      this.content = template.content && template.content.body ? template.content.body : ''
      if (this.checkHaveCategory(ddaTemplateId)) {
        let data = this.checkHaveCategory(ddaTemplateId)
        this.dataForm.code = data.code
        this.setContentToIframe(this.content)
        return
      }
      let res
      ;[res] = await Promise.all([DdaCodesApi.getLastestCode(template.dda_category_id)])
      if (res.result) {
        if (res.result.code) {
          this.dataForm.code = res.result.code.Code ? res.result.code.Code : ''
          if (res.result.code.WarningMessage && this.userProfile.type != 'COMPANY') {
            toastr.warning(res.result.code.WarningMessage)
          }
        }
        this.dataDefault.listCategoriesAndCode.push({
          id: ddaTemplateId,
          dda_category_id: template.dda_category_id,
          code: this.dataForm.code
        })
        this.setContentToIframe(this.content)
      }
      if (this.dataForm.code) {
        this.$refs['formCreate'].clearValidate('code')
      }
    },
    changeCode(code) {
      this.setContentToIframe(this.content)
    },
    setContentToIframe(content) {
      setTimeout(() => {
        this.dataDefault.listParamMergeFields['{{@SoVanBan}}'] = this.dataForm.code
        this.bodyIframe = MethodService.mergeField(
          MethodService.decodeHTML(content),
          this.dataDefault.listParamMergeFields
        )
        let iframeDiv = document.getElementById('iframe-preview-ed').contentWindow.document.body
        iframeDiv.innerHTML = this.bodyIframe
        iframeDiv.style.width = '210mm'
        iframeDiv.style.margin = '0 auto'
        iframeDiv.getElementsByTagName('div')[0].style.padding = '10mm 15mm'
      }, 400)
    },
    checkHaveCategory(ddaTemplateId) {
      if (!ddaTemplateId) return false
      let template = this.dataDefault.listCategoriesAndCode.find(item => item.id == ddaTemplateId)
      return template || false
    },
    onChangeEffectedDate(haveEffectedDate) {
      if (!haveEffectedDate) this.dataForm.effected_date = undefined
    },
    onCancelForm() {
      this.$router.push({
        name: 'Admin-ElectronicDocument-create',
        query: { type: this.$route.query.type || 'DOC_SIGN' }
      }).catch(() => {})
    },
    async onSubmitForm() {
      this.$refs['formCreate'].validate(async valid => {
        if (!valid) return
        let data = MethodService.copyObject(this.dataForm)
        data.html = this.bodyIframe
        try {
          await DraffDocumentAutoApi.CheckCode({ code: data.code })
          localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
          this.$router.push({
            name: 'Admin-ElectronicDocument-template-form',
            query: { type: this.$route.query.type || 'DOC_SIGN' }
          }).catch(() => {})
        } catch (error) {
          toastr.error(error.message)
        }
      })
    }
  },
  mounted() {
    this.initDataDefault()
  }
}
</script>

<style lang="scss" scoped>
.form {
  width: 620px;
  padding: 5px;
  background: #fff;
  margin-right: 25px;
  height: calc(100vh - 145px);
  .form__create {
    height: calc(100vh - 155px);
    overflow-y: auto;
    padding: 10px;
    border: 1px solid #7e7e7e;
  }
}
.button-group {
  justify-content: flex-end;
  margin-top: 10px;
}
.preview {
  width: 100%;
  background: #fff;
  .preview-content {
    box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    height: calc(100vh - 145px);
  }
}
.title-note {
  font-size: 15px;
  line-height: 22px;
}
::v-deep .custom-label {
  width: 390px;
  align-items: center;
  justify-content: space-between;
  .el-switch {
    .el-switch__core {
      border-radius: 10px;
      &:after {
        border-radius: 10px;
      }
    }
  }
}
::v-deep span {
  font-family: LexendDeca Regular !important;
}
</style>
